import React, { Component } from 'react';

//componentes
import PlanillaI from './planillaI'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanillaI />
            </div>
        );
    }

}
export default Index;